import { css } from 'styled-components';
import { regular } from 'components/Button/styles/variants';
import { BaseButtonProps } from 'types';
import { buttonBorderRadiusBySizeDecorator } from 'utils';

export const roundButton = ({ background, ...rest }: BaseButtonProps) => css`
	${regular(rest)}
	line-height: 2.4rem;
	${buttonBorderRadiusBySizeDecorator(rest)}
`;
